<template>
  <!--srccomponentsgui_tabsgui_tabsvuehtmlStart-->

  <div id="defaultId1" class="ueqCkmp" name="header">
    <div id="gf9e12" class="u687b7">
      <slot id="c605d2"> </slot>
    </div>
  </div>
  <!--srccomponentsgui_tabsgui_tabsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

//importEnd

export default {
  name: "",
  props: {},
  mounted() {},
  components: {},
  data() {
    return {
      // isMenu
      isMenu: true,
    };
  },
  methods: {},

  computed: {
    tabs() {
      return this.$slots.default
        .map((item) => item.data)
        .filter((item) => item);
    },
  },
};
</script>
<style>
.ueqCkmp {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.u687b7 {
  display: flex;
  padding-right: 20px;
  flex: auto;
  align-items: center;
  width: 100%;
}

@media screen and (max-width: 1920px) {
  .uJeKUqr {
    padding-left: 0px !important;
  }
  .u52ab1 {
    margin-right: 2em;
  }
  .u687b7 {
    padding-right: 14px;
  }
}
@media screen and (max-width: 1439px) {
  .u52ab1 {
    margin-right: 2em;
  }
  .u687b7 {
    padding-right: 10px;
  }
}
</style>
